import React from 'react';
import { useHistory } from 'react-router-dom';
import A from '../../../common/A';
import { Header } from '../common';
import { URL } from '../../../../constant';

function Success() {
  const { LOGIN } = URL.ACCOUNT;
  const history = useHistory();

  return (
    <React.Fragment>
      <Header title="회원가입" type="join" />
      <div className="layout-def log_in sign with_bottom_area">
        <div className="container">
          <div className="inner">
            <div className="center_wrap">
              <div className="logo_wrap">
                <div className="logo">
                  <img src="./static/images/common/img_congrat@2x.png" alt="" />
                </div>
              </div>
              <div className="noti_wrap">
                <div className="noti1">환영합니다!</div>
                <div className="noti2">
                  <span>abc123@wjtb.com</span> (으)로
                  <br />
                  가입 확인 메일이 전송되었습니다.
                  <br />
                  계정 보호를 위해 이메일 주소 인증을 완료해 주세요.
                </div>
              </div>
            </div>
            <div className="bottom_wrap btn_wrap">
              <A
                className="btn btn-blue"
                onClick={() => history.push(LOGIN)}
              >
                로그인
              </A>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default Success;